export default __webpack_public_path__ + "static/media/closeall.8551c690.svg";